import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginSignup.css";

const LoginSignup = ({ setUser }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("revoraUser", JSON.stringify(form));
    setUser(form);
    navigate("/"); // Redirect to homepage
  };

  return (
    <section className="login-page">
      <div className="login-container glass">
        <h1>{isLogin ? "Welcome Back" : "Join Revora"}</h1>
        <p className="login-subtext">
          {isLogin
            ? "Log in to explore, configure, and customize your dream car."
            : "Sign up and start your luxury automotive journey with Revora."}
        </p>

        <form className="login-form" onSubmit={handleSubmit}>
          {!isLogin && (
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={form.name}
              onChange={handleChange}
              required
            />
          )}
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />
          <button type="submit" className="login-btn">
            {isLogin ? "Login" : "Sign Up"}
          </button>
        </form>

        <p className="toggle-text">
          {isLogin ? "New to Revora?" : "Already have an account?"}{" "}
          <span onClick={() => setIsLogin(!isLogin)}>
            {isLogin ? "Create one" : "Login here"}
          </span>
        </p>
      </div>
    </section>
  );
};

export default LoginSignup;
